import type { AdminStore } from '.';

export type StoreStatus =
  | 'active'
  | 'banned'
  | 'suspended'
  | 'review'
  | 'closed'
  | 'unpublished'
  | 'deleted';

/**
 * The backend has no single `status` column — it's the combination of 0/1 flags
 * on the store row. This collapses them for badges/filters, most-severe first.
 */
export const deriveStoreStatus = (s: AdminStore): StoreStatus => {
  if (s.deleted) return 'deleted';
  if (s.banned) return 'banned';
  if (s.suspended) return 'suspended';
  if (s.review) return 'review';
  if (s.admin_closed || !s.active) return 'closed';
  if (!s.published) return 'unpublished';
  return 'active';
};

export const STORE_STATUS_LABEL: Record<StoreStatus, string> = {
  active: 'Active',
  banned: 'Banned',
  suspended: 'Suspended',
  review: 'In review',
  closed: 'Closed',
  unpublished: 'Unpublished',
  deleted: 'Deleted',
};

export const STORE_STATUS_TONE: Record<StoreStatus, string> = {
  active: 'bg-green-100 text-green-800',
  banned: 'bg-red-200 text-red-900',
  suspended: 'bg-red-100 text-red-800',
  review: 'bg-amber-100 text-amber-800',
  closed: 'bg-slate-100 text-slate-600',
  unpublished: 'bg-gray-100 text-gray-700',
  deleted: 'bg-gray-200 text-gray-500',
};
